import { ImportacaoTalaoItau, RespostaImportaItau } from 'src/app/@shared/models/importacoes/importacoes.model';
import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { ImportacaoService } from 'src/app/services/importacoes/importacao.service';

@Component({
  selector: 'app-importacoes',
  templateUrl: './importacoes.component.html',
  styleUrls: ['./importacoes.component.scss']
})
export class ImportacoesComponent implements OnInit {

  constructor(private imporatacaoService: ImportacaoService) { }

  ngOnInit() {

  }
  respostaImportaItau: RespostaImportaItau;

  importacaoTalaoItau: any[];
  itensOk: ImportacaoTalaoItau[] = [];
  isLoading: boolean;

  processaItens() {
    this.itensOk = [];
    this.importacaoTalaoItau.forEach(item => {
      let importa = new ImportacaoTalaoItau();
      importa.pedidoId = item['NRT'];
      importa.segmento = item['Cliente'];
      importa.destinatario = item['Destinatario'];
      importa.cidade = item['Cidade'];
      importa.cep = this.padLeft(item['CEP'], '0', 8);
      importa.uf = item['UF'];
      importa.descricaoFinal = item['Descrição'];
      importa.dataPrimeiraTentativa = item['1° Tentativa'];
      importa.descricaoPrimeiraTentativa = item['Status 1'];
      importa.dataSegundaTentativa = item['2° Tentativa'];
      importa.descricaoSegundaTentativa = item['Status 2'];
      importa.dataTerceiraTentativa = item['3° Tentativa'];
      importa.descricaoTerceiraTentativa = item['Status 3'];
      importa.dataPostagem = item['Data da entrega'];
      importa.agencia = item['Agencia'];
      importa.conta = item['Conta'];
      importa.primieiraFolhaCheque = item['Nr. Primeira Folha Cheque'];
      importa.ultimaFolhaCheque = item['Nr. Ultima Folha Cheque'];
      importa.ar = item['AR'];
      importa.dataColeta = item['Data Recepcao Fisica'];
      importa.status = item['Status'];
      importa.distribuicao = item['Distribuição'];
      importa.motivoPostagem = item['Motivo de Postagem'];
      importa.arCorreios = item['NrRedespacho'];
      importa.dataPrevistaEntrega = item['Data Entrega Prevista'];
      importa.comentarioEntrega = item['Comentario Entrega'];
      importa.imagem = item['Imagem'];
      this.itensOk.push(importa);
    });
  }

  onFileChange(ev) {
    this.importacaoTalaoItau = [];
    this.respostaImportaItau = null;
    let workBook = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = () => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', dateNF: 'dd/MM/yyyy', cellDates: true });
      this.importacaoTalaoItau = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial = XLSX.utils.sheet_to_json(sheet, { defval: '', dateNF: 'dd/MM/yyyy' });
        return initial;
      }, {});

      this.processaItens();
    }
    reader.readAsBinaryString(file);
  }


  enviarProcessados() {
    this.isLoading = true;
    this.imporatacaoService.processaItens(this.itensOk).subscribe(
      obj => {
        this.respostaImportaItau = obj;
        this.isLoading = false;
        this.itensOk = [];
      }, error => {
        console.log(error);
        this.isLoading = false;
      }
    )
  }

  exportItensErro(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.respostaImportaItau.listaError);
    worksheet['A1'] = { t: 's', v: 'NRT' };
    worksheet['B1'] = { t: 's', v: 'Cliente' };
    worksheet['C1'] = { t: 's', v: 'Destinatario' };
    worksheet['D1'] = { t: 's', v: 'Cidade' };
    worksheet['E1'] = { t: 's', v: 'CEP' };
    worksheet['F1'] = { t: 's', v: 'UF' };
    worksheet['G1'] = { t: 's', v: 'Descrição' };
    worksheet['H1'] = { t: 's', v: '1° Tentativa' };
    worksheet['I1'] = { t: 's', v: 'Status 1' };
    worksheet['J1'] = { t: 's', v: '2° Tentativa' };
    worksheet['K1'] = { t: 's', v: 'Status 2' };
    worksheet['L1'] = { t: 's', v: '3° Tentativa' };
    worksheet['M1'] = { t: 's', v: 'Status 3' };
    worksheet['N1'] = { t: 's', v: 'Data da entrega' };
    worksheet['O1'] = { t: 's', v: 'Agencia' };
    worksheet['P1'] = { t: 's', v: 'Conta' };
    worksheet['Q1'] = { t: 's', v: 'Nr. Primeira Folha Cheque' };
    worksheet['R1'] = { t: 's', v: 'Nr. Ultima Folha Cheque' };
    worksheet['S1'] = { t: 's', v: 'AR' };
    worksheet['T1'] = { t: 's', v: 'Data Recepcao Fisica' };
    worksheet['U1'] = { t: 's', v: 'Status' };
    worksheet['V1'] = { t: 's', v: 'Distribuição' };
    worksheet['W1'] = { t: 's', v: 'Motivo de Postagem' };
    worksheet['X1'] = { t: 's', v: 'NrRedespacho' };
    worksheet['Y1'] = { t: 's', v: 'Entrada' };
    worksheet['Z1'] = { t: 's', v: 'Data Processamento' };
    worksheet['AA1'] = { t: 's', v: 'Data Entrega Prevista' };
    worksheet['AB1'] = { t: 's', v: 'Comentario Entrega' };
    worksheet['AC1'] = { t: 's', v: 'Imagem' };
    worksheet['AD1'] = { t: 's', v: 'Erros' };


    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    XLSX.writeFile(workbook, 'itensComErro.xlsx');
  }

  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr((size * -1), size);
  }
}
